import { Box, Icon, Text, Tooltip, TriggerText } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled, IconPanorama360Filled } from '@zillow/constellation-icons';

import {
  tourCardImageContainerStyles,
  tourCardImageOverlayStyles,
  tourCardImageRecipe,
  tourCardImageSelectedStyles,
} from '../styles';

import type { FC } from 'react';

type TourCardImageProps = {
  imageSrc: string | undefined;
  onClick?: () => void | null;
  isHidden?: boolean;
  isSelected?: boolean;
  size?: 'sm' | 'md' | 'full';
};

const TourCardImage: FC<TourCardImageProps> = ({
  imageSrc = '',
  onClick = null,
  isHidden = false,
  isSelected = false,
  size = 'sm',
}) => (
  <Box css={tourCardImageRecipe.raw({ size, isClickable: onClick !== null })} onClick={onClick ?? undefined}>
    {isHidden && (
      <Box css={tourCardImageOverlayStyles} data-testid="TourCardImage-overlay">
        <Tooltip.Root>
          <Tooltip.Trigger>
            <TriggerText css={{ borderBottom: 'initial' }}>Hidden 3D tour</TriggerText>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content>
              <Text>
                Floor plans with units only show 3D tours at the unit level. Add your 3D tour to individual units to
                have 3D tours show on our sites.
              </Text>
              <Tooltip.Arrow />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Box>
    )}
    {isSelected && (
      <Box css={tourCardImageSelectedStyles} data-testid="TourCardImage-selected">
        <Icon size="lg" css={{ color: 'icon.accent.brand.hero' }} render={<IconCheckmarkCircleFilled />} />
      </Box>
    )}
    {imageSrc ? (
      <Box
        css={tourCardImageContainerStyles}
        style={{ backgroundImage: `url(${imageSrc})` }}
        data-testid="TourCardImage-container"
      />
    ) : (
      <Box css={tourCardImageContainerStyles} data-testid="TourCardImage-container">
        <Icon size="xl" css={{ color: 'icon.subtle' }} render={<IconPanorama360Filled />} />
      </Box>
    )}
  </Box>
);

export type { TourCardImageProps };
export default TourCardImage;
